import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPanoramaView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="panorama-view"><path d="M5.92656 4.09056C3.51652 3.57766 1 5.29742 1 7.8842V16.111C1 18.706 3.53065 20.4252 5.94459 19.9081C10.0281 19.0335 13.9719 19.0335 18.0554 19.9081C20.4693 20.4252 23 18.706 23 16.111V7.8842C23 5.29741 20.4835 3.57766 18.0734 4.09056C13.9684 4.96418 10.0316 4.96418 5.92656 4.09056Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPanoramaView;
